export default "__VITE_ASSET__SBqXVRyk__"